import styled from "styled-components";
import { Placement } from "tippy.js";
import { transition } from "@evergis/ui";

export const LanguageButtonContainer = styled.span<{ placement?: Placement }>`
  display: inline-flex;
  align-items: center;
  height: ${({ placement }) => (placement === "left-start" ? 0.5 : 2.5)}rem;
  margin-right: 0.5rem;
`;

export const LanguageButton = styled.div<{ img: string }>`
  cursor: pointer;
  display: flex;
  width: 2rem;
  height: 1rem;
  mask-image: ${({ img }) => `url(${img})`};
  background-color: ${({ theme: { palette } }) => palette.icon};
  transition: background-color ${transition.hover};

  :hover {
    background-color: ${({ theme: { palette } }) => palette.textPrimary};
  }
`;

export const LanguageMenuItem = styled.div`
  display: flex;
`;

export const LanguageMenuContainer = styled.div`
  margin: 0.5rem 0;
`;
